export class JaasperServiceError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = "JaasperServiceError";
  }
}

export class UserRetrievalError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = "UserRetrievalError";
  }
}

export class DocumentContentError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = "DocumentContentError";
  }
}

export class DocumentUpdateError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = "DocumentUpdateError";
  }
}

export class DocumentUploadError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = "DocumentUploadError";
  }
}

export class DocumentDeletionError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = "DocumentDeletionError";
  }
}

export class PDFDownloadError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = "PDFDownloadError";
  }
}

export class CaseCreationTimeoutError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = "CaseCreationTimeoutError";
  }
}

export class CaseCreationError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = "CaseCreationError";
  }
}

export class CaseIdMissingError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = "CaseIdMissingError";
  }
}

export class CaseRetrievalError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = "CaseRetrievalError";
  }
}

export class CaseUpdateError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = "CaseUpdateError";
  }
}

export class IndexRetrievalError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = "IndexRetrievalError";
  }
}

export class LlmModelRetrievalError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = "LlmModelRetrievalError";
  }
}

export class IndexCreationTimeoutError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = "IndexCreationTimeoutError";
  }
}

export class IndexCreationError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = "IndexCreationError";
  }
}

export class RagPromptTimeoutError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = "RagPromptTimeoutError";
  }
}

export class RagPromptError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = "RagPromptError";
  }
}

export class LlmServerDownError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = "LlmServerDownError";
  }
}

export class WorkflowLoadError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = "WorkflowLoadError";
  }
}

export class LlmModelLoadError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = "LlmModelLoadError";
  }
}

export class PlaybookLoadError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = "PlaybookLoadError";
  }
}

export class PlaybookDocumentLoadError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = "PlaybookDocumentLoadError";
  }
}

export class PlaybookDocumentMissingError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = "PlaybookDocumentMissingError";
  }
}

export class PlaybookDocumentContentParseError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = "PlaybookDocumentContentParseError";
  }
}

export class PlaybookDocumentContentError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = "PlaybookDocumentContentError";
  }
}

export class ParseJsonError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = "ParseJsonError";
  }
}
